import fp from 'lodash/fp';
import * as actions from './actions';

export const INITIAL_STATE = {
    trades: [],
    originalTradesSelection: []
};

const setTrades = fp.set('trades');

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_TRADES_PRICED_TODAY: {
            return {
                trades: action.trades,
                originalTradesSelection: action.trades
            };
        }
        case actions.SET_TRADE_CHECKED: {
            return {
                ...state,
                trades: state.trades
                    .map(trade => (trade.name !== action.id ? trade
                        : fp.set('selected', action.checked, trade)))
            };
        }
        case actions.SET_ALL_UNBOOKED_TRADES_CHECKED: {
            return setTrades(state.trades.map(trade => (!trade.booked ? fp.set('selected', action.checked, trade) : trade)), state);
        }
        default:
            return state;
    }
}
